import { render, staticRenderFns } from "./ConversationDetail.vue?vue&type=template&id=7b5faef4&"
import script from "./ConversationDetail.vue?vue&type=script&lang=js&"
export * from "./ConversationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports